import React, {Component} from 'react';
import {Button, Card, CardContent, CardHeader, CardFooter} from 'framework7-react';
import {getFramework7} from './App';

/// Allows us to handle HTML content retrieved from Wordpress.
function createMarkup(markup) {
    return {__html: markup};
}

/// A search result representing a building.
///
/// The buildings tab displays a list of SearchRow components which makes
/// up the search results.
export default class SearchRow extends Component {

    /// Setup this component to handle opening the corresponding popup.
    constructor(props, context) {
        super(props, context);
        this.showDetail = this.showDetail.bind(this);
    }

    /// Open the BuildingDetailPopup showing more information about the building.
    showDetail = () => {
        getFramework7().popup('.popup-' + this.props.building.slug);
    };

    render() {
        return (
            <div className="search-row" onClick={this.showDetail}>
                <Card>
                    <CardHeader>{this.props.building.name}
                        <i className="chevron_right f7-icons">chevron_right</i></CardHeader>
                    <CardContent>
                        <div dangerouslySetInnerHTML={createMarkup(this.props.building.description)}></div>
                    </CardContent>
                    <CardFooter>
                      <Button>View More</Button>
                    </CardFooter>
                </Card>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/SearchRow.jsx